export default __webpack_public_path__ + "static/media/area-1.f2fe1b6e.png";